module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu@2x.f197176b.jpg";